export default __webpack_public_path__ + "static/media/logo-primary-monochromo-white.0f8c92d8.svg";